/* src/app/modules/portal/components/hello-there/hello-there.component.scss */
:host {
  display: flex;
  flex-direction: row;
}
[cycle] {
  position: absolute;
  opacity: 0;
  overflow: hidden;
  white-space: nowrap;
  transform: translateY(-2rem);
  transition: all 1s;
}
.animate-in {
  transform: translateY(0rem);
  opacity: 1;
  text-wrap: balance;
}
.animate-out {
  transform: translateY(2rem);
  opacity: 0;
  text-wrap: balance;
}
/*# sourceMappingURL=hello-there.component.css.map */
